import DateIcon from '@/components/DateIcon';
import {
  getActivityPresentation,
  getActivityTitle,
} from '@/components/Lead/activityPresentation';
import PrettyDate from '@/components/PrettyDate';
import { LeadActivityModel } from '@/typings/models/LeadActivity';
import { Space } from 'antd';
import classNames from 'classnames';
import { useIntl } from 'umi';
import styles from './index.less';

export default function ActivityItem({
  activity,
  onActivityItemClick,
}: {
  activity: LeadActivityModel;
  onActivityItemClick: () => void;
}) {
  const intl = useIntl();
  const label = getActivityTitle(activity, intl);
  const date = activity.created;
  const { icon } = getActivityPresentation(activity.activity_type);

  return (
    <div
      onClick={onActivityItemClick}
      className={classNames(
        styles.projectDetailItemContainer,
        styles.activityItemContainer,
        styles.projectDetailItemContainerClickable,
      )}
    >
      {icon && <span className={styles.activityItemIcon}>{icon}</span>}
      <div className={styles.projectDetailItemContent}>
        <div className={styles.projectDetailItemHeader}>{label}</div>
        <div className={styles.projectDetailItemBody}>
          <Space size={4}>
            <DateIcon date={date} />
            <PrettyDate date={date} />
          </Space>
        </div>
      </div>
    </div>
  );
}
